import React from 'react';

const AIEvaluation = ({ AIScores, t }) => {
  const summary =
    AIScores?.summary ?? t('candidate-drawer.ai-evaluation.no-ai-summary');
  const rankings = AIScores?.rankings ?? [];
  const hasEvaluations = rankings.length > 0;
  return (
    <section>
      {hasEvaluations ? (
        rankings.map((item, index) => (
          <AIEvaluationItem key={index} item={item} />
        ))
      ) : (
        <p>{t('candidate-drawer.ai-evaluation.no-ai-evaluations')}</p>
      )}
      <div className='flex flex-col'>
        <strong>{t('candidate-drawer.ai-evaluation.ai-summary')}</strong>
        <p>{summary}</p>
      </div>
    </section>
  );
};

export default AIEvaluation;

const AIEvaluationItem = ({ item }) => {
  return (
    <p>
      <strong>{item.name}</strong>: {item.score} – {item.description}
    </p>
  );
};
